import { Component, EventEmitter, Output, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { SelectionModel } from '@angular/cdk/collections';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DriverNameComponent } from '@shared/components/driver-name/driver-name.component';
import { EHailingDriverComponent } from '@shared/components/e-hailing-driver/e-hailing-driver.component';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { Select, Store } from "@ngxs/store";
import { Observable, Subject, takeUntil } from "rxjs";
import { CoveragePopupComponent } from '@shared/components/modal/coverage-popup/extra-coverage-popup.component';
import { CALCULATE_PREMIUM, CALCULATE_PREMIUM_PAYLOAD, PATCH_STEP3, RESET_EHAILING, STORE_AV_IND_OVERRIDE, STORE_COVERAGE_TYPE, STORE_COVERAGE_VEHICLE_DETAILS, STORE_EXTRA_COVER_PACKAGE, STORE_SHOWED_ONE_ALLIANZ_POP_UP, UPDATE_COVERAGE_ALERT } from '@store/sat-motor/sat-motor.action';
import { UserResponse } from '@interfaces/user';
import { FormatDecimalCoveragePipe } from '@shared/pipes/format-decimal-coverage/format-decimal.pipe';
import { RemoveCommaPipe } from '@shared/pipes/remove-comma/remove-comma.pipe';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OneAllianzMessageComponent } from '@shared/components/modal/one-allianz-message/one-allianz-message.component';
import { WarningPopupComponent } from '@shared/components/modal/warning-popup/warning-popup.component';
import { SumInsuredInputModelComponent } from "@shared/components/modal/sum-insured-input-model/sum-insured-input-model.component";
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-extra-coverage',
  standalone: true,
  imports: [
    SharedModule,
    DriverNameComponent,
    EHailingDriverComponent,
    MatSelectModule,
    MatCheckboxModule,
    MatFormFieldModule
  ],
  templateUrl: './extra-coverage.component.html',
  styleUrl: './extra-coverage.component.scss',
  providers: [DecimalPipe],
})
export class ExtraCoverageComponent {
  @Input() coverageFmGroup!: FormGroup;
  @Input() isComprehensive = false;
  @Input() isThirdParty = false;
  @Input() isThirdPartyFireTheft = false;
  @Input() defaultDriver: any;
  @Input() partnerInfo: any;
  @Output() isSelected = new EventEmitter();
  @Output() selectedItem = new EventEmitter();
  templateDialogRef?: NxModalRef<any>;
  oneAllianzModal?: NxModalRef<OneAllianzMessageComponent>;
  warningPopupModal?: NxModalRef<WarningPopupComponent>;
  extraCoverDetailForm: FormGroup;
  @Select(SatMotorState.coveragePremium) coveragePremium$: Observable<SatMotorState>;
  @ViewChild(DriverNameComponent) driverNameChild: DriverNameComponent;
  private destroy$ = new Subject<void>();
 
  constructor(private readonly dialogService: NxDialogService, private fb: FormBuilder, private store: Store, private cdr: ChangeDetectorRef) {
    this.decimalFmt = new FormatDecimalCoveragePipe();
    this.numberFmt = new RemoveCommaPipe();
    this.extraCoverDetailForm = this.fb.group({
      checkedAll: [false],
      extraCoverPackage: [""],
      extraCoverPackageSummary: [""],
      driverNameDetails: new FormGroup({}),
      ehailingDriverDetails: new FormGroup({}),
      subCoverSumInsured: [""], // for sub sumInsured
      //subCoverSumInsured:["", [Validators.required]],
      dropdownSubCover: [""],// for sub dropdown
      extraCoverPackageDto: [""]
    });
 
  }
  componentDialogRef?: NxModalRef<CoveragePopupComponent>;
  selection: any;
  allComplete: boolean = true;
  subCovList: any;
  subCovPackageList: any;
  subCovPackageTwoList: any;  
  subCovPackageThreeList: any;  
  extraCoverDetails: any;
  packageDescription: any;
  userInfo: any;
  extraCoverSecondList: any = [];
  extraCoverThirdList: any = [];
  extraCoverList: any = [];
  checkPrivateHireCar = [];
  privateHireCarIsSelected: boolean = false;
  rahmahExtraCoverList = [];
  topExtraCoverList = [];
  defaultedExtraCoverList = [];
  fixedDefaultedExtraCoverList = [];
  allSelectedWithRahmahExtraCoverList = [];
  selectExtraCoverAppDrive = [];
  unnamedDriverExtraCoverList = [];
  coverDto: any;
  updateSelectedAndAllListToOPUS: any;
  subExtraCoverDropdownList: any;
  numberFmt: any;
  decimalFmt: any;
  isWaiver: boolean = false;
  isAllDriver: boolean = false;
  subCovPackageDesc: any;
  costInd: boolean = false;
  isNextBtnInd: boolean = false;
  selectedCheckboxP2p = [];
  selectedCheckboxP2pCode = [];
  vendorCodeList = [];
  subCoverList = [];
  p2pCodeList = []; //for design purpose
  countCallSubCovPackageList = 0;
  coveragePayload: any;
  disableAddMore: boolean = false;
  //disableWaiverCheckbox: boolean = false;
  perilWarningPopup: boolean = false;
  noOfDayLabel = "NO. OF DAY : ";
  amountPerDayLabel = "AMOUNT PER DAY (RM) : ";
  planUnitLabel = "PLAN / UNIT : ";
  amountPerDayFormName = "_AMOUNT_PER_DAY";
  noOfDayFormName = "_NO_OF_DAY";
  mtRoadPlacementTblInd: boolean = false;
  mtRoadEligibleInd: boolean = false;
  recalculatePremiumForWaiver: boolean = false;
  autoSelectMRWDropdown: boolean = false;
  getLatestMtRoadInd: boolean = false;
  alimCustomerIndicator: any;
  issuanceInfo : any;
  dialogRef?: NxModalRef<any>;
  packagePIPPPrompEdit: boolean = false;

  ngOnInit() {
    this.userInfo = this.store.selectSnapshot<UserResponse>((state) => state.UserState.user);
    this.coverageFmGroup.controls["extraCoverDetails"] = this.extraCoverDetailForm;
    this.selection = new SelectionModel<any>(true, []);
    this.extraCoverList.forEach(element => {
      this.selection.select(element)
    });
 
    this.extraCoverList = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.extracover?.extraCoverPackage);
    this.extraCoverDetailForm.patchValue({
      dropdownSubCover: this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.extracover?.dropdownSubCover)
    });
 
    this.isAllDriver = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.extracover?.driverNameDetails.vehicleAlldrvrInd);
    this.isWaiver = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.extracover?.driverNameDetails.vehicleUnNamedDrvrInd);
    this.alimCustomerIndicator = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step2?.alimCustomerIndicator);
    this.issuanceInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.issuance.issuance);
 
    this.setExtraCoverageForm();
  }
 
  ngAfterViewInit() {
    this.coveragePremium$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      let stCngeNote: any, stRiskList: any, stCoverList: any, stCoverDto: any;
      if (state) {
        if ((stCngeNote = state["cngeNote"]) && (stRiskList = stCngeNote["riskList"]) && stRiskList.length > 0) {
          this.mtRoadPlacementTblInd = stCngeNote?.mtRoadPlacementTblInd;
          this.mtRoadEligibleInd = stCngeNote?.mtRoadEligibleInd;
 
          if ((stCoverList = stRiskList[0]["coverList"]) && stCoverList.length > 0) {
            this.subCovPackageDesc = stCoverList[0].subCovPackageDesc;
            this.costInd = stCoverList[0].costInd;
            this.subCoverList = stCoverList[0].subCoverList; //p2p save to db
            this.isAllDriver = stCoverList[0].vehicleAlldrvrInd;
            this.isWaiver = stCoverList[0].vehicleUnNamedDrvrInd;
 
            this.coverageFmGroup.patchValue({
              basicPremium: stCoverList[0].basicPremium,
            });
            if ((stCoverList[0]["coverDto"])) {
              stCoverDto = stCoverList[0]["coverDto"];
              this.coverDto = stCoverList[0]["coverDto"]; //third party missing premium
              if (stCoverDto && stCoverDto["subCovList"]) {
                this.subCovList = stCoverDto["subCovList"];
                this.subCovList = this.subCovList.map((obj) => {
                  return {
                    ...obj,
                    subcoverNarrCode: obj.templateCode,
                    subcoverNarrDesc: obj.sumInsuredDisplay,
                  };
                });
                this.updateSelectedAndAllListToOPUS = this.subCovList;
              }
              if (stCoverDto && stCoverDto["subCovPackageList"]) {
                this.subCovPackageList = stCoverDto["subCovPackageList"][0];
                this.subCovPackageTwoList = stCoverDto["subCovPackageList"][1];
                this.subCovPackageThreeList = stCoverDto["subCovPackageList"][2];
              }
 
              if (this.subCovPackageList?.packageCode) {
                this.rahmahExtraCoverList = this.subCovList.filter(o1 => o1.top == true && o1.subCovPackage === this.subCovPackageList.packageCode &&
                  o1.enabled == false && o1.subCoverPrem == 0);
              } else {
                this.rahmahExtraCoverList = [];
              }
 
              if (this.subCovPackageTwoList?.packageCode && this.subCovPackageTwoList?.selected) {
                this.extraCoverSecondList = this.subCovList.filter(o1 => o1.top == true && o1.subCovPackage === this.subCovPackageTwoList?.packageCode &&
                  o1.enabled == false && o1.subCoverPrem == 0);
              } else {
                this.extraCoverSecondList = [];
              }
              if (this.subCovPackageThreeList?.packageCode && this.subCovPackageThreeList?.selected) {
                this.extraCoverThirdList = this.subCovList.filter(o1 => o1.top == true && o1.subCovPackage === this.subCovPackageThreeList?.packageCode &&
                  o1.enabled == false && o1.subCoverPrem == 0);
              } else {
                this.extraCoverThirdList = [];
              }
            }
          }
        }
      }
 
      if (this.subCovList) {
 
        const packageCode = [this.subCovPackageList,this.subCovPackageTwoList,this.subCovPackageThreeList].find(pkg => pkg?.selected)?.packageCode ?? null;
        const validPackageCode = packageCode !== undefined ? packageCode : null;
 
        this.topExtraCoverList = this.subCovList.filter(o1 =>
          o1.top === true && o1.selected === true
          // cater specific for motor RW & motor ERW
          && ((o1.subCoverCode === "PAB-RW" && o1.planCode != null && o1.planCode !== '' && this.mtRoadPlacementTblInd == false) || (o1.subCoverCode === "PAB-ERW" && o1.planCode !== '') || o1.enabled === false)
          && o1.subCoverPrem == 0
          && (validPackageCode === null || o1.subCovPackage !== validPackageCode)
        );
 
        this.defaultedExtraCoverList = this.subCovList.filter(o1 => o1.top === true && o1.selected === false && (validPackageCode === null || o1.subCovPackage !== validPackageCode));
        this.extraCoverList = this.subCovList.filter(o1 => o1.selected === true);
 
        if(this.subCovPackageList?.selected || this.subCovPackageTwoList?.selected || this.subCovPackageThreeList?.selected ){ // package is not selected but there are still sub cover with package
          this.extraCoverList = this.subCovList.filter(o1 => o1.selected === true && (validPackageCode === null || o1.subCovPackage !== validPackageCode));
        }
       
        //filter topExtraCoverList from this.extraCoverList
        this.extraCoverList = this.extraCoverList.filter(o1 => !this.topExtraCoverList.some(o2 => o2.subCoverCode === o1.subCoverCode));
        //for all driver checkbox
        this.unnamedDriverExtraCoverList = this.subCovList.filter(o1 => o1.selected === true && o1.subCoverCode === "A200");
 
        this.allSelectedWithRahmahExtraCoverList = [
          ...this.rahmahExtraCoverList,
          ...this.topExtraCoverList,
          ...this.extraCoverList,
          ...this.extraCoverSecondList,
          ...this.extraCoverThirdList
        ];
 
        this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList); //to save quotation
        this.extraCoverDetailForm.controls['extraCoverPackageDto'].setValue(this.updateSelectedAndAllListToOPUS);//send to ODM
 
        this.toDisplayInSummary();
        this.privateHireCar();
        this.setExtraCoverageForm();
        this.setSelectedOptionalPackageAfterSaveAsDraft();
        this.remainingSeeMoreList();
        //this.checkWaiverAndAllDriver();
        this.setPackageFormInput();
        if (this.packagePIPPPrompEdit === !true && this.allSelectedWithRahmahExtraCoverList?.find(obj => obj.selected === true && (obj.subCovPackage === 'PIPP_0100' || obj.subCovPackage === 'PIPP_0200') && obj.subCoverCode === '89' && obj.subCoverSumInsured == 0)){
          this.packagePIPPPrompEdit = true;
          let covWindSCreen = this.allSelectedWithRahmahExtraCoverList?.find(obj => obj.selected === true && (obj.subCovPackage === 'PIPP_0100' || obj.subCovPackage === 'PIPP_0200') && obj.subCoverCode === '89');
          this.openPopupInputValue(covWindSCreen.description, covWindSCreen.subCoverDescp, covWindSCreen.mtExtCovDtoList, covWindSCreen.subCoverSumInsured, covWindSCreen.subCoverCode);
        }
        if (this.allSelectedWithRahmahExtraCoverList?.find(obj => obj.selected === true && (obj.subCovPackage === 'PIPP_0100' || obj.subCovPackage === 'PIPP_0200' && obj.subCoverCode === '89'))?.subCoverSumInsured > 0) { //remove validation when value loaded from fresh.
          this.extraCoverDetailForm.get("89")?.reset(this.allSelectedWithRahmahExtraCoverList?.find(obj => obj.selected === true && (obj.subCovPackage === 'PIPP_0100' || obj.subCovPackage === 'PIPP_0200') && obj.subCoverCode === '89')?.subCoverSumInsured);
          this.extraCoverDetailForm.get("89")?.setErrors(null);
        }
      }
    });
  }
 
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
 
  toDisplayInSummary(){
 
    this.topExtraCoverList = this.topExtraCoverList.map((obj) => {
      if ((obj.subCoverCode === 'PAB3' || obj.subCoverCode === 'PAB-DG') && obj.selected === true) {
        return { ...obj, subCoverBenefitList: obj.cngeSubCoverBenefitDtoList };
      }
      return obj;
    });
   
    let toDisplayInSummary = {
      subCovPackageList: [this.subCovPackageList, this.subCovPackageTwoList, this.subCovPackageThreeList].find(pkg => pkg?.selected) ?? null,
      subCovPackageDesc: this.subCovPackageDesc,
      costInd: this.costInd,
      rahmahPackageList: [this.rahmahExtraCoverList,this.extraCoverSecondList,this.extraCoverThirdList].find(list => list && list.length > 0) ?? null,
      topExtraCoverList: this.topExtraCoverList,
      selectedExtraCoverList: this.extraCoverList,
    }
 
    this.extraCoverDetailForm.controls['extraCoverPackageSummary'].setValue(toDisplayInSummary);
  }
 
  checkWaiverAndAllDriver() {
    if (this.rahmahExtraCoverList?.length > 0 && this.costInd) {
      const waiverExtraCover = this.rahmahExtraCoverList.find(item => ((item.subCoverCode === 'A200' || item.subCoverCode === 'A200a'  || item.subCoverCode === 'A200VW') && item.subCovPackage));
      const allDriverExtraCover = this.rahmahExtraCoverList.find(item => (( item.subCoverCode === 'M02' || item.subCoverCode === 'M02VW') && item.subCovPackage));
 
      if (waiverExtraCover && !this.recalculatePremiumForWaiver) {
        this.recalculatePremiumForWaiver = true;
        this.driverNameChild.disabledWaiverCheckbox();
        this.driverNameChild.waiverIndOnChange();
      }else if(allDriverExtraCover){
        this.driverNameChild.disabledAllDriverCheckbox();
      }
    } else if (this.extraCoverSecondList?.length > 0 && this.costInd) {
      const waiverExtraCover = this.extraCoverSecondList.find(item => ((item.subCoverCode === 'A200' || item.subCoverCode === 'A200a' || item.subCoverCode === 'A200VW') && item.subCovPackage));
      const allDriverExtraCover = this.extraCoverSecondList.find(item => ((item.subCoverCode === 'M02' || item.subCoverCode === 'M02VW') && item.subCovPackage));
 
      if (waiverExtraCover && !this.recalculatePremiumForWaiver) {
        this.recalculatePremiumForWaiver = true;
        this.driverNameChild.disabledWaiverWOCheckbox();
      } else if (allDriverExtraCover) {
        this.driverNameChild.disabledAllDriverCheckbox();
      }
    } else if (this.extraCoverThirdList?.length > 0 && this.costInd) {
      const waiverExtraCover = this.extraCoverThirdList.find(item => ((item.subCoverCode === 'A200' || item.subCoverCode === 'A200a' || item.subCoverCode === 'A200VW') && item.subCovPackage));
      const allDriverExtraCover = this.extraCoverThirdList.find(item => ((item.subCoverCode === 'M02' || item.subCoverCode === 'M02VW') && item.subCovPackage));

      if (waiverExtraCover && !this.recalculatePremiumForWaiver) {
        this.recalculatePremiumForWaiver = true;
        this.driverNameChild.disabledWaiverWOCheckbox();
      } else if (allDriverExtraCover) {
        this.driverNameChild.disabledAllDriverCheckbox();
      }
    } else {
       this.recalculatePremiumForWaiver = false;
       let waiverExtraCover =  this.extraCoverList.find(item => (item.subCoverCode === 'A200'  || item.subCoverCode === 'A200a' && item.selected && !item.subCovPackage))
       this.driverNameChild.enabledWaiverCheckbox();
       this.driverNameChild.enabledAllDriverCheckbox();
       if(waiverExtraCover){
        this.driverNameChild.tickWaiverCheckbox(true);
       }else{
        this.driverNameChild.tickWaiverCheckbox(false);
       }
    }
  }
 
  remainingSeeMoreList() {
    const packageCode = this.subCovPackageList?.packageCode
    let originalExtraCoverList = this.subCovList.filter(o1 => !this.allSelectedWithRahmahExtraCoverList.some(o2 => o1.subCoverCode === o2.subCoverCode) &&
      (packageCode === undefined || packageCode === '' || o1.subCovPackage !== packageCode) && o1.top == false
    );
 
    if (originalExtraCoverList && originalExtraCoverList?.length == 0) {
      this.disableAddMore = true;
    } else {
      this.disableAddMore = false;
    }
  }
 
  setSelectedOptionalPackageAfterSaveAsDraft() { //cr14
    if (this.costInd) {
      //removed enabled == true for Active quotation
      let optionalPackageList = this.subCovList.filter(o1 => o1.top == true && o1.selected == true && 
        (o1.subCovPackage === this.subCovPackageList?.packageCode || o1.subCovPackage === this.subCovPackageTwoList?.packageCode || o1.subCovPackage === this.subCovPackageThreeList?.packageCode));
      this.countCallSubCovPackageList++;
      if (optionalPackageList && optionalPackageList.length > 0 && this.countCallSubCovPackageList == 1) {
        this.store.dispatch(new UPDATE_COVERAGE_ALERT({ alimCustomerEligible: false, alimCustomerEligibleShowed: true, bettermentEligible: false, bettermentEligibleShowed: true }));
        const matchedPackageCode = optionalPackageList[0].subCovPackage;
        this.emitData(true, matchedPackageCode, "defaultedCR14Value", true);
      }else{
        this.checkWaiverAndAllDriver();
      }
    }else{
      this.checkWaiverAndAllDriver();
    }
  }
 
  setExtraCoverageForm() {
    this.extraCoverList?.forEach((obj, idx) => {
      obj.mtExtCovDtoList?.forEach((subItem, subIdx) => {
        if (subItem.type === 'INPUT') {
          if (!subItem.disable) {
            this.extraCoverDetailForm.addControl(
              obj.subCoverCode,
              new FormControl('', [
                Validators.required,
                Validators.min(0.01),
                Validators.pattern(/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/)
              ])
            );
            if (obj.subCoverSumInsured > 0) {
              this.extraCoverDetailForm.patchValue({
                [obj.subCoverCode]: this.decimalFmt.transform(obj.subCoverSumInsured)
              });
            }
          } else {
            if (!this.extraCoverDetailForm.contains(obj.subCoverCode) && obj.subCoverSumInsured > 0) {
              this.extraCoverDetailForm.addControl(obj.subCoverCode, new FormControl(this.decimalFmt.transform(obj.subCoverSumInsured)));
              this.extraCoverDetailForm.get(obj.subCoverCode)?.disable();
            }
          }
 
        } else if (subItem.type === 'DROPDOWN' || subItem.type === 'CHECKBOX_P2P') {
 
          if (obj.subCoverCode === '112' && subItem.label === this.noOfDayLabel) {
            let noOfDayFormName = obj.subCoverCode + this.noOfDayFormName;
            this.extraCoverDetailForm.addControl(noOfDayFormName, new FormControl('', Validators.required));
            if (obj.subCoverNumberOfDays > 0 || obj.subCoverDays > 0) {
              const noOfDays = obj.subCoverNumberOfDays > 0 ? obj.subCoverNumberOfDays : obj.subCoverDays;
 
              this.extraCoverDetailForm.patchValue({
                [noOfDayFormName]: this.getSubCoverNumberOfDaysAsString(noOfDays)
              });
            }
 
          } else if (obj.subCoverCode === '112' && subItem.label === this.amountPerDayLabel) {
            let amountPerDayFormName = obj.subCoverCode + this.amountPerDayFormName;
            this.extraCoverDetailForm.addControl(amountPerDayFormName, new FormControl('', Validators.required));
            if (obj.subCoverAmtday > 0) {
              this.extraCoverDetailForm.patchValue({
                [amountPerDayFormName]: obj.subCoverAmtday.split('.')[0]
              });
            }
 
          } else if (subItem.type === 'CHECKBOX_P2P') {
            let multiCheckboxFormName = "CHECKBOX_P2P";
            this.extraCoverDetailForm.addControl(multiCheckboxFormName, new FormControl('', Validators.required));
            if (obj.vendorList) {
              this.p2pCodeList = obj.vendorList.split(",");
              this.extraCoverDetailForm.patchValue({
                CHECKBOX_P2P: obj.vendorList.split(",")
              });
            } else {
              this.p2pCodeList = []; //design purpose
            }
          } else {
            this.extraCoverDetailForm.addControl(obj.subCoverCode, new FormControl('', Validators.required));
            if (obj.planCode) {
              this.extraCoverDetailForm.patchValue({
                [obj.subCoverCode]: obj.planCode
              });
            }
          }
        }
      });
    });
  }
 
  setExtraCoverageFormForDisabledInput() {
 
    this.extraCoverList?.forEach((obj, idx) => {
      if (!this.extraCoverDetailForm.contains(obj.subCoverCode)) {
        obj.mtExtCovDtoList?.forEach((subItem, subIdx) => {
          if (subItem.type === 'INPUT' && subItem.disable && obj.subCoverSumInsured > 0) {
            this.extraCoverDetailForm.addControl(obj.subCoverCode, new FormControl(this.decimalFmt.transform(obj.subCoverSumInsured)));
            this.extraCoverDetailForm.get(obj.subCoverCode)?.disable();
          }
        });
      }
    });
  }
 
  setPackageFormInput(){
    if (this.subCovPackageList.selected) {
      this.addControlsFromList(this.rahmahExtraCoverList);
    } else if (this.subCovPackageTwoList.selected) {
      this.addControlsFromList(this.extraCoverSecondList);
    } else if (this.subCovPackageThreeList.selected) {
      this.addControlsFromList(this.extraCoverThirdList);
    }
  }
  private addControlsFromList(list: any[]) {
    list?.forEach(obj => {
      obj.mtExtCovDtoList?.forEach(subItem => {
        if (subItem.type === 'INPUT') {
          this.extraCoverDetailForm.addControl(
            obj.subCoverCode,
            new FormControl('', [
              Validators.required,
              Validators.min(0.01),
              Validators.pattern(/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/)
            ])
          );
        }
      });
    });
  }
  openPopupComp(popup_type: any) {
    this.componentDialogRef = this.dialogService.open(CoveragePopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "90%",
      maxWidth: "800px",
      maxHeight: "95vh",
      data: {
        popup_type: popup_type,
        selectedExtraCoverList: this.allSelectedWithRahmahExtraCoverList,
        originalExtraCoverList: this.subCovList,
        packageCode: this.subCovPackageList?.packageCode
      },
    });
 
    this.componentDialogRef.afterClosed().subscribe((result) => {
      console.log('result is : ' + result)
      if (result) {
        result.selection.forEach(objDialog => {
          const newObj = { ...objDialog, selected: true };
          this.extraCoverList.push(newObj);
          this.extraCoverList.forEach(element => {
            this.selection.select(element)
          });
          this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
            if (objDialog.subCoverCode === obj.subCoverCode) {
              return { ...obj, selected: !obj.selected };
            }
            return obj;
          });
        });
 
        this.privateHireCar();
        this.allSelectedWithRahmahExtraCoverList = [
          ...this.rahmahExtraCoverList,
          ...this.topExtraCoverList,
          ...this.extraCoverList,
          ...this.extraCoverSecondList,
          ...this.extraCoverThirdList
        ];
        this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
        this.calculatePremium(false);
      }
    });
  }
 
  emitData(item: boolean, code: any, location: any, callWaiverMethod: boolean) {
    if (this.extraCoverDetailForm.contains(code)) {
      this.extraCoverDetailForm.removeControl(code);
    }
 
    if (code === '112') {
      if (this.extraCoverDetailForm.contains(code + this.amountPerDayFormName)) {
        this.extraCoverDetailForm.removeControl(code + this.amountPerDayFormName);
      }
 
      if (this.extraCoverDetailForm.contains(code + this.noOfDayFormName)) {
        this.extraCoverDetailForm.removeControl(code + this.noOfDayFormName);
      }
    }
 
    if (code === 'A207') {
      if (this.extraCoverDetailForm.contains("CHECKBOX_P2P")) {
        this.extraCoverDetailForm.removeControl("CHECKBOX_P2P");
      }
    }
   
    if (!this.mtRoadEligibleInd && !item && location === 'bottom' && (code === 'PAB-RW' || code === 'PAB-ERW') &&
      this.alimCustomerIndicator && this.alimCustomerIndicator === 'YES' && this.issuanceInfo.productCode === '080100') {
      this.mtRoadEligibleInd =  true;
      this.mtRoadPlacementTblInd = false;
      this.getLatestMtRoadInd = true;
      this.store.dispatch(new STORE_SHOWED_ONE_ALLIANZ_POP_UP(true));
    }
 
 
    if ((this.subCovPackageList?.packageCode === 'JPPP_0100' || this.subCovPackageList?.packageCode === 'JPPP_0200') && this.subCovPackageList?.selected) {
      let perils = this.extraCoverList.find(obj => (obj.subCoverCode === 'A221' || obj.subCoverCode === '57'));
      if (perils && perils.subCoverCode !== code &&  (code === 'A221' || code === '57')) {
          this.warningPopup("warningPopupTwo", "Please select 'Inclusion of Special Perils' or 'Limited Special Perils Cover' to continue.");
          return;
      }
    }
 
    if (location === 'defaultedCR14Value' && this.subCovPackageTwoList == null && this.subCovPackageThreeList ==null ) {
      this.subCovPackageList = {
        ...this.subCovPackageList,
        selected: item
      };
    }
 
    if (location === 'topHeader') {
      
      const allPackages = [
        this.subCovPackageList,
        this.subCovPackageTwoList,
        this.subCovPackageThreeList
      ];
      
      this.recalculatePremiumForWaiver = allPackages.some(
        p => p?.selected && p.packageCode !== code
      );
      
      [this.subCovPackageList, this.subCovPackageTwoList, this.subCovPackageThreeList] =
        allPackages.map(pkg => {
          if (!pkg) return null;
      
          if (pkg.packageCode === code) {
            return { ...pkg, selected: !pkg.selected };
          } else {
            return { ...pkg, selected: false };
          }
        });
      this.isWaiver = false;
      this.isAllDriver = false;
 
      //for optional package with waiver (untick)
      const waiverExtraCover = this.rahmahExtraCoverList.find(item => ((item.subCoverCode === 'A200' || item.subCoverCode === 'A200VW')  && item.subCovPackage));
      if (waiverExtraCover && this.costInd && !item) {
        this.isWaiver = false;
        this.updateAllExtraCoverList(waiverExtraCover.subCoverCode);
      }
 
      const allDriverExtraCover = this.rahmahExtraCoverList.find(item => ((item.subCoverCode === 'M02' || item.subCoverCode === 'M02VW') && item.subCovPackage));
      if (allDriverExtraCover && this.costInd && !item) {
        this.isAllDriver = true;
        this.updateAllExtraCoverList(allDriverExtraCover.subCoverCode);
      }

      let packageSelected=[this.subCovPackageList, this.subCovPackageTwoList, this.subCovPackageThreeList].find(pkg => pkg?.selected) ?? null;
      let packageSubCoverList=[this.rahmahExtraCoverList,this.extraCoverSecondList,this.extraCoverThirdList].find(list => list && list.length > 0) ?? null;

      let coverWindScreen = packageSubCoverList?.find(obj => obj.subCoverCode === '89' )??null;
      let extraCoverWindScreen = this.extraCoverList?.find(obj => obj.subCoverCode === '89' )??null;

      if ((packageSelected?.packageCode != 'PIPP_0100' && packageSelected?.packageCode != 'PIPP_0200') && ((coverWindScreen != null && packageSelected != null) || packageSelected == null)) {
        this.extraCoverDetailForm.get("89")?.reset(null);
        this.extraCoverDetailForm.get("89")?.setErrors(null);
        this.extraCoverDetailForm.removeControl("89");
      }else if ((packageSelected?.packageCode == 'PIPP_0100' || packageSelected?.packageCode == 'PIPP_0200') && (extraCoverWindScreen && (extraCoverWindScreen.subCovPackage==null||extraCoverWindScreen.subCovPackage==""))){
        this.extraCoverDetailForm.get("89")?.reset(null);
        this.extraCoverDetailForm.get("89")?.setErrors(null);
        this.extraCoverDetailForm.removeControl("89");
        extraCoverWindScreen.subCoverSumInsured = null;
      }
    }
 
    if (location === 'defaultedExtraCover') {
      this.defaultedExtraCoverList.forEach((obj, index) => {
        if (code == obj.subCoverCode) {
          this.defaultedExtraCoverList.splice(index, 1);
          const newObj = { ...obj, selected: true };
          this.extraCoverList.push(newObj);
          this.extraCoverList.sort((a, b) => {
            if (a.top !== b.top) {
              return a.top ? -1 : 1;  // 'true' (top) comes first
            }
            return a.sequenceNumber - b.sequenceNumber;
          });
        }
      });
      this.setExtraCoverageFormForDisabledInput();
 
      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
        if (code === obj.subCoverCode) {
          return { ...obj, selected: !obj.selected };
        }
        return obj;
      });
    } else {
      this.updateAllExtraCoverList(code);
    }
    this.allSelectedWithRahmahExtraCoverList = [
          ...this.rahmahExtraCoverList,
          ...this.topExtraCoverList,
          ...this.extraCoverList,
          ...this.extraCoverSecondList,
          ...this.extraCoverThirdList
        ];
    this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
    this.calculatePremium(callWaiverMethod);
  }
 
  updateAllExtraCoverList(code){
    this.extraCoverList.forEach((obj, index) => {
      if (code == obj.subCoverCode) {
        this.extraCoverList.splice(index, 1);
        if (obj.top == true) {
          const newObj = { ...obj, selected: false };
          this.defaultedExtraCoverList.push(newObj);
          // Ascending order defaultedExtraCoverList
          this.defaultedExtraCoverList.sort((a, b) => {
            return a.sequenceNumber - b.sequenceNumber;
          });
 
          this.extraCoverList.sort((a, b) => {
            if (a.top !== b.top) {
              return a.top ? -1 : 1;  // 'true' (top) comes first
            }
            return a.sequenceNumber - b.sequenceNumber;
          });
        }
      }
    });
 
    this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
      if (code === obj.subCoverCode) {
        if (!obj.selected == false) {
          return { ...obj, selected: !obj.selected, subCoverPrem: 0, mtExtCovDtoList: null };
 
        } else {
          return { ...obj, selected: !obj.selected };
        }
      }
      return obj;
    });
  }
 
  privateHireCar() {
    this.checkPrivateHireCar = this.extraCoverList.find(top => top.subCoverCode === 'A202');
    if (this.checkPrivateHireCar) {
      this.privateHireCarIsSelected = true;
    } else {
      this.privateHireCarIsSelected = false;
      this.extraCoverDetailForm.controls["ehailingDriverDetails"].reset();
      this.store.dispatch(new RESET_EHAILING())
    }
  }
 
  selectExtraCover($event) {
    this.isAllDriver = $event;
  }
 
  selectWaiver($event: boolean) {
    this.isWaiver = $event;
    this.emitData(this.isWaiver, "A200", "bottom", false);
  }
 
  selectAllDriver($event: boolean) {
    this.isAllDriver = $event;
    this.emitData(this.isWaiver, "M02", "bottom", false);
  }
 
  removeExtraCover($event) {
    let obj = this.subCovList.find(item => item.subCoverCode === $event);
    this.extraCoverList = this.extraCoverList.filter(item => item.subCoverCode !== $event);
 
    this.extraCoverList.forEach(element => {
      this.selection.deselect(element)
    });
    this.allSelectedWithRahmahExtraCoverList = this.topExtraCoverList.concat(this.extraCoverList);
  }
 
  checkedAllChange() {
    if (this.extraCoverDetailForm.controls['checkedAll'].value) {
      this.defaultedExtraCoverList.forEach((obj) => {
        if (obj.enabled) {
          const matchMRW = this.extraCoverList.find(objMRW => objMRW.subCoverCode === 'PAB-RW');
          const matchMERW = this.extraCoverList.find(objERW => objERW.subCoverCode === 'PAB-ERW');
          if (matchMRW?.enabled == true && obj.subCoverCode === 'PAB-ERW') {
            return;
          }
 
          if (matchMERW?.enabled == true && obj.subCoverCode === 'PAB-RW') {
            return;
          }
 
          if ((this.subCovPackageList?.packageCode === 'JPPP_0100' || this.subCovPackageList?.packageCode === 'JPPP_0200') && this.subCovPackageList?.selected) {
            const perils = this.extraCoverList.find(item => ((item.subCoverCode === 'A221' && item.selected) || (item.subCoverCode === '57' && item.selected)))
            if (perils && perils.subCoverCode !== obj.subCoverCode && (obj.subCoverCode === 'A221' || obj.subCoverCode === '57')) {
              if(!this.perilWarningPopup){
                this.warningPopup2("warningPopupTwo", "Please select 'Inclusion of Special Perils' or 'Limited Special Perils Cover' to continue.");
                this.perilWarningPopup = true;
              }
              return;
            }
          }
 
          const newObj = { ...obj, selected: true };
          this.extraCoverList.push(newObj);
        }
      });
      this.perilWarningPopup = false;
      this.defaultedExtraCoverList = [];
 
      this.extraCoverList.sort((a, b) => {
        if (a.top !== b.top) {
          return a.top ? -1 : 1;
        }
        return a.sequenceNumber - b.sequenceNumber;
      });
 
      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj2) => {
        const matchingObj = this.extraCoverList.find(obj1 => obj1.subCoverCode === obj2.subCoverCode);
        if (matchingObj) {
          return { ...obj2, selected: true };
        }
        return obj2;
      });
 
      this.setExtraCoverageForm();
    } else {
      this.extraCoverList.forEach(obj => {
        if (this.extraCoverDetailForm.contains(obj.subCoverCode)) {
          this.extraCoverDetailForm.removeControl(obj.subCoverCode);
        }
      })
 
      if(this.isWaiver){
        this.extraCoverList = this.extraCoverList.filter(obj => obj.subCoverCode === 'A200')
        this.updateSelectedAndAllListToOPUS = this.extraCoverList.filter(obj => obj.subCoverCode === 'A200')
      }else if(this.isAllDriver){
        this.extraCoverList = this.extraCoverList.filter(obj => obj.subCoverCode === 'M02')
        this.updateSelectedAndAllListToOPUS = this.extraCoverList.filter(obj => obj.subCoverCode === 'M02')
      } else{
        this.extraCoverList = [];
        this.updateSelectedAndAllListToOPUS = [];
      }
     
    }
 
 
 
    this.privateHireCar();
    this.allSelectedWithRahmahExtraCoverList = [
          ...this.rahmahExtraCoverList,
          ...this.topExtraCoverList,
          ...this.extraCoverList,
          ...this.extraCoverSecondList,
          ...this.extraCoverThirdList
        ];
    this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList); //to save quotation
 
    this.calculatePremium(false);
 
 
  }
 
  get extraCoverPackage() {
    return this.extraCoverDetailForm.controls["extraCoverPackage"];
  }
 
  calculatePremium(callWaiverMethod) {
    this.store.dispatch(new STORE_AV_IND_OVERRIDE(true));
    this.store.dispatch(new STORE_SHOWED_ONE_ALLIANZ_POP_UP(true)); // to cancel type of coverage 1 allianz popup
    let typeOfCoverage = this.coverageFmGroup.controls["typeOfCoverage"].getRawValue();
    let vehicleDetails = this.coverageFmGroup.controls["vehicleDetails"].getRawValue();
 
    let coveragePremiumPayload = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coveragePremium);
    let driverNameList = this.populateDriverNameData();
   
    if (!coveragePremiumPayload) { //active quotation optional package
      coveragePremiumPayload = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3?.coverage?.coveragePremiumPayload);
      if (coveragePremiumPayload) {
        coveragePremiumPayload = {
          ...coveragePremiumPayload,
          operator: this.userInfo.userId
        }
      }
    }
 
    let packageCode = "";
    if (this.subCovPackageList?.selected) {
      packageCode = this.subCovPackageList?.packageCode;
    } else if(this.subCovPackageTwoList?.selected) {
      packageCode = this.subCovPackageTwoList?.packageCode;
    } else if(this.subCovPackageThreeList?.selected) {
      packageCode = this.subCovPackageThreeList?.packageCode;
    }
 
    if (coveragePremiumPayload) {
      coveragePremiumPayload = {
        ...coveragePremiumPayload,
        cngeNote: {
          ...coveragePremiumPayload.cngeNote,
          riskList: [{
            ...coveragePremiumPayload.cngeNote.riskList[0],
            coverList: [{
              ...coveragePremiumPayload.cngeNote.riskList[0].coverList[0],
              subCoverList: this.allSelectedWithRahmahExtraCoverList,
              vehicleUnNamedDrvrInd: this.isWaiver,
              vehicleAlldrvrInd: this.isAllDriver,
              coverDto: {
                ...this.coverDto,
                subCovList: [
                  ...this.updateSelectedAndAllListToOPUS
                ],
                subCovPackageList: this.subCovPackageThreeList
                ? [this.subCovPackageList, this.subCovPackageTwoList, this.subCovPackageThreeList]
                : this.subCovPackageTwoList
                  ? [this.subCovPackageList, this.subCovPackageTwoList]
                  : [this.subCovPackageList],               
                   vendorCodeList: this.vendorCodeList ? this.vendorCodeList : null,
                extCovPackageSelected: packageCode
              },
              alimCustomerEligible: null,
            }],
            cngeRiskDrvrDtoList: driverNameList
          }]
        },
        operator: this.userInfo.userId
      }
 
      if ('avInd' in typeOfCoverage) {
        coveragePremiumPayload = {
          ...coveragePremiumPayload,
          cngeNote: {
            ...coveragePremiumPayload.cngeNote,
            riskList: [{
              ...coveragePremiumPayload.cngeNote.riskList[0],
              avInd: typeOfCoverage?.avInd,
              coverList: [{
                ...coveragePremiumPayload.cngeNote.riskList[0].coverList[0],
                avInd: typeOfCoverage?.avInd
              }]
            }]
          }
        }
      }
 
      if (!this.isNextBtnInd || this.autoSelectMRWDropdown || this.getLatestMtRoadInd) {
        coveragePremiumPayload = {
          ...coveragePremiumPayload,
          cngeNote: {
            ...coveragePremiumPayload.cngeNote,
            mtRoadPlacementTblInd: this.mtRoadPlacementTblInd,
            mtRoadEligibleInd: this.mtRoadEligibleInd
          },
          operator: this.userInfo.userId
        }
      }
 
      if (!coveragePremiumPayload.cngeNote?.riskList?.[0]?.vehicleCapacity) {
        coveragePremiumPayload = {
          ...coveragePremiumPayload,
          cngeNote: {
            ...coveragePremiumPayload.cngeNote,
            riskList: [{
              ...coveragePremiumPayload.cngeNote.riskList[0],
              vehicleCapacity: vehicleDetails?.vehicleCapacity,
            }]
          }
        }
        this.store.dispatch(new PATCH_STEP3("coveragePremium", coveragePremiumPayload));
      }
 
      this.store.dispatch(new CALCULATE_PREMIUM(coveragePremiumPayload)).subscribe((state) => {
        if (this.isNextBtnInd) {
          this.openPopupOneAllianz();
          if (callWaiverMethod) {
            this.checkWaiverAndAllDriver();
          }
        }
      });
    }
 
  }
 
  populateDriverNameData() {
    let driverNameForm = this.coverageFmGroup.controls["driverNameForm"].getRawValue();
    const namedDriverList = driverNameForm.rows
    let cngeRiskDrvrDtoList = namedDriverList.map((driver) => {
      let driverName;
      if (driver.driverName) {
        driverName = driver.driverName;
      } else if (driver?.cngeRiskDrvrPkDto?.driverName) {
        driverName = driver.cngeRiskDrvrPkDto.driverName;
      }
 
      let cngeRiskDrvrPkDto = {
        cngeRiskDrvrPkDto: {
          driverName: driverName ? driverName : "",
          driverType: "NORM",
        },
        driverId: driver.driverId,
        driverAge: driver.driverAge === 'N/A' ? 0 : driver.driverAge,
        driverSeq: driver.driverSeq,
      };
 
      return cngeRiskDrvrPkDto;
    });
    return cngeRiskDrvrDtoList;
  }
 
 
 
  populateVehicleDetailsData(data) {
    let selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3?.coverage?.selectedMakeModel);
    let makeModelPrintInd = data.makeModelPrintInd ? "Y" : "N";
    return {
      ...data, ...selectedMakeModel,
      makeModelPrintInd: makeModelPrintInd,
      importStatus: selectedMakeModel.importStatus,
      vehModelNvic: selectedMakeModel.vehModelCodeNvic,
      vehicleModel: selectedMakeModel.vehModelCodeNvic,
      nvicNo: selectedMakeModel.nvicCode,
      vehicleCapacity: this.numberFmt.transform(data.vehicleCapacity)
    };
  }
 
  onChangeSubCoverSumInsured(subCoverCodeValue: any, subCoverSumInsuredValue: any, subItemType: any) {
    let formatSubCoverSumInsuredValue = subCoverSumInsuredValue.value ? subCoverSumInsuredValue.value : 0.00;
 
    if (subItemType === 'INPUT') {
      let formattedValue = parseFloat(formatSubCoverSumInsuredValue).toFixed(2);
      if (/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/.test(formattedValue)) {
        console.log("Valid format: 11 characters with 2 decimal places");
      } else {
        this.extraCoverDetailForm.controls[subCoverCodeValue].markAsTouched();
        return;
      }
    }
 
    if (formatSubCoverSumInsuredValue) {
      formatSubCoverSumInsuredValue = formatSubCoverSumInsuredValue.toString().replace(/,/g, "");
 
 
      this.extraCoverList = this.extraCoverList.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue };
        }
        return obj;
      });
 
      this.extraCoverList.sort((a, b) => {
        if (a.top !== b.top) {
          return a.top ? -1 : 1;
        }
        return a.sequenceNumber - b.sequenceNumber;
      });
 
 
      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue };
  }
        return obj;
      });
      this.allSelectedWithRahmahExtraCoverList = [
          ...this.rahmahExtraCoverList,
          ...this.topExtraCoverList,
          ...this.extraCoverList,
          ...this.extraCoverSecondList,
          ...this.extraCoverThirdList
        ];
      this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
      this.calculatePremium(false);
 
    }
  }
 
  populateTypeOfCoverageData(data) {
    return {
      ...data, sumInsured: this.numberFmt.transform(data.sumInsured), excessAmount: this.numberFmt.transform(data.excessAmount),
      basicPremium: this.numberFmt.transform(data.basicPremium), annualPremium: this.numberFmt.transform(data.annualPremium),
      grossPremium: this.numberFmt.transform(data.grossPremium), ncdAmount: this.numberFmt.transform(data.ncdAmount),
      ncdPercentage: this.numberFmt.transform(data.ncdPercentage)
    };
  }
 
  onChangeProduct(subCoverCodeValue: any, dropdownCode: any, dropdownDesc: any) {
    const updateAndSortLists = (property: string, value: any) => {
      this.extraCoverList = this.extraCoverList.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, [property]: value };
        }
        return obj;
      });
 
      //update to OPUS list
      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, [property]: value };
        }
        return obj;
      });
 
      // Sorting logic
      this.extraCoverList.sort((a, b) => {
        if (a.top !== b.top) {
          return a.top ? -1 : 1;
        }
        return a.sequenceNumber - b.sequenceNumber;
      });
 
      // Combining lists
      this.allSelectedWithRahmahExtraCoverList = [
          ...this.rahmahExtraCoverList,
          ...this.topExtraCoverList,
          ...this.extraCoverList,
          ...this.extraCoverSecondList,
          ...this.extraCoverThirdList
        ];
      this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
    };
 
    if (dropdownDesc === this.planUnitLabel) {
      updateAndSortLists('planCode', dropdownCode);
    } else if (dropdownDesc === this.noOfDayLabel) {
      updateAndSortLists('subCoverNumberOfDays', dropdownCode);
      updateAndSortLists('subCoverDays', dropdownCode);
    } else if (dropdownDesc === this.amountPerDayLabel) {
      updateAndSortLists('subCoverAmtPerDay', dropdownCode);
      updateAndSortLists('subCoverAmtday', dropdownCode);
    } else if (dropdownDesc === 'CHECKBOX_P2P') { //might change
      updateAndSortLists('vendorList', dropdownCode);
    }
 
    this.calculatePremium(false);
  }
 
  getSubCoverNumberOfDaysAsString(code: string) {
    return code.toString();
  }
 
  motorRoadWarriorValidation(): Boolean {
    if (this.mtRoadEligibleInd) {
      const item = this.subCoverList.find(item => (item.subCoverCode === 'PAB-RW' || item.subCoverCode === 'PAB-ERW') && !item.selected);
      if (!item) {
        this.mtRoadEligibleInd =  false;
        this.mtRoadPlacementTblInd = false;
        this.autoSelectMRWDropdown = true;
        this.isNextBtnInd = true;
        this.calculatePremium(false);
        return false;
      }
    }
 
    if ((this.subCovPackageList?.packageCode === 'JPPP_0100' || this.subCovPackageList?.packageCode === 'JPPP_0200') && this.subCovPackageList?.selected) {
      const mandatoryExtraCoverage = this.extraCoverList.find(item => ((item.subCoverCode === 'A221' && item.selected) || (item.subCoverCode === '57' && item.selected)))
      if (!mandatoryExtraCoverage) {
        this.warningPopup2("warningPopupTwo", "Please select 'Inclusion of Special Perils' or 'Limited Special Perils Cover' to continue.");
        return false;
      }
    }
    return true;
  }
 
  warningPopup(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
    this.warningPopupModal.afterClosed().subscribe((result) => {
      this.calculatePremium(false);
    });
  }
 
  warningPopup2(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
  }
 
  selectionChange(event: any): void {
    this.selectedCheckboxP2p = event;
    this.vendorCodeList = []
 
    if (!Array.isArray(this.selectedCheckboxP2p)) {
      this.selectedCheckboxP2p = [];
    }
 
    //for coverDto save to db
    this.vendorCodeList = event.map(code => ({
      description: code
    }));
 
    //for subCoverList calculate premium
    // this.cngeSubcoverVendor = event.map(code => ({
    //   vendorCode: code
    // }));
 
    const selectedCodesString = this.selectedCheckboxP2p.join(",");
 
    this.onChangeProduct("A207", selectedCodesString, "CHECKBOX_P2P");
  }
 
  removeDecimal(value: any) {
    if (value) {
      return value.replace(/\.00(?=\D|$)/, "");
    }
    return value;
  }
 
  openPopupOneAllianz() {
    let showPrompt = true;
    let hasShowedOneAllianzPopUp = this.store.selectSnapshot<boolean>((state) => state.SatMotorState.data?.hasShowedOneAllianzPopUp);
    if (!hasShowedOneAllianzPopUp || this.autoSelectMRWDropdown) {
      this.getLatestMtRoadInd = false;
      this.autoSelectMRWDropdown = false;
      let isNonEligibleOneAllianz = false;
      let oneAllianzData = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2.oneAllianzData ?? null);
 
      if (oneAllianzData) {
        if (oneAllianzData.oriAlimCustomerIndi === 'YES' && oneAllianzData.alimCustomerIndi === 'NO') {
          isNonEligibleOneAllianz = true;
 
        } else if (oneAllianzData.oriAlimCustomerIndi === 'YES' && oneAllianzData.alimCustomerIndi === 'YES') {
          isNonEligibleOneAllianz = false;
 
        } else if ((oneAllianzData.oriAlimCustomerIndi === 'NO' || !oneAllianzData.oriAlimCustomerIndi) && oneAllianzData.alimCustomerIndi === 'YES') {
          isNonEligibleOneAllianz = false;
 
        } else {
          showPrompt = false;
        }
      }
 
      if (showPrompt) {
        this.oneAllianzModal = this.dialogService.open(OneAllianzMessageComponent, {
          showCloseIcon: false,
          disableClose: true,
          width: "400px",
          maxWidth: "400px",
          data: {
            showNonEligible: isNonEligibleOneAllianz
          }
        });
      }
 
      this.oneAllianzModal.afterClosed().subscribe((result) => {
        this.calculatePremium(false);
        this.isNextBtnInd = false;
      });
    }
 
  }
 
  removeNewLinesFromOpus(value: any, item: any, location: any) {
    if (value && value.includes("$NEWLINES")) {
      if (location === 'middle' && (item.subCoverCode === 'PAB-RW' || item.subCoverCode === 'PAB-ERW' || item.subCoverCode === 'PAB3')) {
        return value.replace(/.*\$NEWLINES/, '');
      }
      return value.replace("$NEWLINES", "<br>");
    }
    return value;
  }

  openPopupInputValue(description: string | null, subCoverCodeDescription: string | null, mtExtCovDtoList: any[], subCoverSumInsured:number,subCoverCode:any) {
    const packageBenefitDescription = description || subCoverCodeDescription;

    this.dialogRef = this.dialogService.open(SumInsuredInputModelComponent, {
      
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: "95%",
      maxWidth: "930px",
      data: { 
        packageBenefitDescription: packageBenefitDescription,
        mtExtCovDtoList: mtExtCovDtoList,
        subCoverSumInsured : subCoverSumInsured && subCoverSumInsured !=0  ? subCoverSumInsured : "",
        subCoverCode: subCoverCode     
      }
    }
    );

    this.dialogRef.afterClosed().subscribe((result) => {
      this.extraCoverDetailForm.get(subCoverCode)?.markAsTouched();
      if (result) {
        let formatSubCoverSumInsuredValue = result.sumInsured.toString().replace(/,/g, "");

        if(this.subCovPackageList?.selected){
          this.rahmahExtraCoverList = this.rahmahExtraCoverList.map(obj =>
            obj.subCoverCode === result.subCoverCode
              ? { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue,
                sumInsuredDisplay:mtExtCovDtoList[0].label + this.decimalFmt.transform(result.sumInsured) }
              : obj
          );
        }
        else if(this.subCovPackageTwoList?.selected){
          this.extraCoverSecondList = this.extraCoverSecondList.map(obj =>
            obj.subCoverCode === result.subCoverCode
              ? { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue,
                sumInsuredDisplay:mtExtCovDtoList[0].label + this.decimalFmt.transform(result.sumInsured) }
              : obj
          );
        }else if (this.subCovPackageThreeList?.selected){
          this.extraCoverThirdList = this.extraCoverThirdList.map(obj =>
            obj.subCoverCode === result.subCoverCode
              ? { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue,
                sumInsuredDisplay:mtExtCovDtoList[0].label + this.decimalFmt.transform(result.sumInsured) }
              : obj
          );
        }
         
        this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map(obj =>
          obj.subCoverCode === result.subCoverCode
            ? { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue,
              sumInsuredDisplay:mtExtCovDtoList[0].label + this.decimalFmt.transform(result.sumInsured) }
            : obj
        );
        this.allSelectedWithRahmahExtraCoverList = [
          ...this.rahmahExtraCoverList,
          ...this.topExtraCoverList,
          ...this.extraCoverList,
          ...this.extraCoverSecondList,
          ...this.extraCoverThirdList
        ];
        this.extraCoverDetailForm.get(result.subCoverCode)?.setValue(this.decimalFmt.transform(result.sumInsured));
        this.extraCoverDetailForm.controls['extraCoverPackage']
          .setValue(this.allSelectedWithRahmahExtraCoverList);
        this.calculatePremium(false);
      }
    });
  }
}
